import { Box, Button, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import logo from "../images/bow_icon.png";

export default function MobileShell({ children, title, onLogout }) {
  return (
    <Box
      sx={{
        minHeight: "100vh",
        bgcolor: "#f6f7fb",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: 480,
          minHeight: "100vh",
          bgcolor: "#fff",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            position: "sticky",
            top: 0,
            zIndex: 20,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            px: 2,
            py: 1.5,
            bgcolor: "#fff",
            borderBottom: "1px solid #eceff3",
          }}
        >
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img src={logo} alt="Bow HIS" width={32} height={32} />
            <Typography sx={{ fontWeight: 800, color: "#172033" }}>
              {title || "Bow HIS"}
            </Typography>
          </Box>

          {onLogout && (
            <Button
              onClick={onLogout}
              size="small"
              startIcon={<LogoutIcon />}
              sx={{ color: "#c2451f", fontWeight: 700 }}
            >
              ออก
            </Button>
          )}
        </Box>

        <Box sx={{ flex: 1 }}>{children}</Box>
      </Box>
    </Box>
  );
}
